/**
 * @fileoverview PUT handler for the "/sdk/debugger/document" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { sdkDebuggerDocumentCacheKeys } from "./constants";
import type { SdkDebuggerDocumentResult, putSdkDebuggerDocumentProps } from "./types";

export const putSdkDebuggerDocument = reactQueryMutationAdapter(
  sdkDebuggerDocumentCacheKeys,
  ({ userIds }: putSdkDebuggerDocumentProps): Promise<SdkDebuggerDocumentResult> => {
    return fetch("/sdk/debugger/document", "PUT", { user_ids: userIds });
  }
);
